import { HTMLAttributes, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

import { useStore } from '@/contexts/store'
import { useTheme } from '@/contexts/theme'

import Typography from './typography'
import { cn } from '@/lib/utils'

export type ScrollDownProps = HTMLAttributes<HTMLDivElement>

const ScrollDown = ({ className, ...props }: ScrollDownProps) => {
  const { theme } = useTheme()
  const { strings } = useStore()
  const root = useRef<HTMLDivElement>(null!)

  useGSAP(
    () => {
      const timeline = gsap.timeline({ repeat: -1, repeatDelay: 0.5 }).fromTo(
        '[data-motion-line]',
        { scaleY: 0 },
        {
          keyframes: [
            { scaleY: 1, ease: 'power1.out', transformOrigin: 'top' },
            {
              scaleY: 0,
              ease: 'power1.inOut',
              transformOrigin: 'bottom',
              delay: 0.2
            }
          ],
          duration: 1
        }
      )

      return () => {
        timeline.revert()
      }
    },
    { scope: root }
  )

  return (
    <div
      ref={root}
      className={cn(
        { dark: theme?.layout === 'dark' },
        'pointer-events-none flex space-x-spacing-lg',
        className
      )}
      data-scroll-down
      {...props}
    >
      <div
        className={cn(
          'relative w-[0.2rem] overflow-hidden bg-white-light/20',
          'bg-text-accent-light/20 dark:bg-text-accent-dark/20'
        )}
      >
        <div className={cn('absolute left-0 top-0 h-full w-full bg-current')} data-motion-line />
      </div>
      <div className="flex">
        <Typography className="text-current">{strings?.labels?.scroll_down}</Typography>
      </div>
    </div>
  )
}

export default ScrollDown
